import { defaultStylingSchema } from '@kitconcept/volto-light-theme/components/Blocks/schema';

export const ContactListStylingSchema = ({ schema, formData, intl }) => {
  defaultStylingSchema({ schema, formData, intl });

  return schema;
};
